import React, { ReactNode } from 'react';

import Markdown from 'react-markdown';

import classes from './MarkdownViewer.module.scss';

type MarkdownViewerProps = {
  content: string;
};

type LinkProps = {
  href?: string;
  children?: ReactNode;
};

export const MarkdownViewer = ({ content }: MarkdownViewerProps) => {
  const renderLink = ({ href, children }: LinkProps) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );

  return (
    <div className={classes.markdownViewer}>
      <Markdown components={{ a: renderLink }}>{content}</Markdown>
    </div>
  );
};
